<template>
  <v-form ref="form" class="">
    <v-row>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Ciclo</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{entry.name}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Status</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{entry.statusText}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Cultura</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{entry.culture.name}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Data de Início Estimada</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{formatDate(entry.startPrediction)}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Data de Início Realizada</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{entry.startDate ? formatDate(entry.startDate) : 'Não Iniciado'}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Data de Término Estimada</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{formatDate(entry.expectedEndDate)}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Data de Término Realizada</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{entry.endDate ? formatDate(entry.endDate) : 'Não Finalizado'}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Variedade(s)</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              <!-- {{formatDate(entry.estimatedFinalDate)}} -->
              <v-chip
                v-for="(item, index) in entry.varieties"
                :key="index"
              >
                {{item.title}}
              </v-chip>
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="">
        
        <v-timeline
          align-top
          dense
        >
          <v-timeline-item
            v-for="(executionOperation, i) in entry.proratedExecutionOperations"
            :key="i"
            :color="operationTypeColor(executionOperation.operationType.kind)"
            :icon="operationTypeIcon(executionOperation.operationType.kind)"
            fill-dot
            :small="$vuetify.breakpoint.smAndDown"
          >
            <v-card
              :color="operationTypeColor(executionOperation.operationType.kind)"
            >
              <v-card-title class="title">
                {{executionOperation.operationDate | formatDate}} - {{executionOperation.operationType.name}}
              </v-card-title>
              <v-card-text class="white text--primary px-0">

                <BaseIndex
                  ref="baseIndex"
                  :loading="loading"
                  :pageLoading="pageLoading"
                  :table-headers="activitiesHeaders"
                  :table-items="executionOperation.activitiesAttributes"
                  :indexNested="true"
                  :maskFields="activitiesHeadersMaskFields"
                  :disablePagination="true"
                  :containSearchBar="false"
                  :containTopToolbar="false"
                  :hasTableTitle="true"
                  tableTitle="Atividades"
                >

                  <template slot="tableFooter">
                    <tr class="d-none d-md-table-row">
                      <td colspan="4"><strong class="title">Total das Atividades</strong></td>
                      <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.activitiesTotalPrice | formatCurrency }}</strong></td>
                    </tr>

                    <!-- for mobile only -->
                    <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header">Total das Atividades</div>
                        <div class="v-data-table__mobile-row__cell"><strong>{{ executionOperation.activitiesTotalPrice | formatCurrency }}</strong></div>
                      </td>
                    </tr>
                  </template>

                </BaseIndex>


                <BaseIndex
                  ref="baseIndex"
                  v-if="executionOperation.exitMovementItems.length > 0"
                  :loading="loading"
                  :pageLoading="pageLoading"
                  :table-headers="exitMovementItemsHeaders"
                  :table-items="executionOperation.exitMovementItems"
                  :indexNested="true"
                  :maskFields="exitMovementItemsHeadersMaskFields"
                  :disablePagination="true"
                  :containSearchBar="false"
                  :containTopToolbar="false"
                  :hasTableTitle="true"
                  tableTitle="Itens Consumidos"
                  class="mt-3"
                >

                  <template slot="tableFooter">
                    <tr class="d-none d-md-table-row">
                      <td colspan="4"><strong class="title">Total dos Itens Consumidos</strong></td>
                      <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.exitMovementItemsTotalPrice | formatCurrency }}</strong></td>
                    </tr>

                    <!-- for mobile only -->
                    <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                      <td class="v-data-table__mobile-row">
                        <div class="v-data-table__mobile-row__header">Total dos Itens Consumidos</div>
                        <div class="v-data-table__mobile-row__cell"><strong>{{ executionOperation.exitMovementItemsTotalPrice | formatCurrency }}</strong></div>
                      </td>
                    </tr>
                  </template>

                </BaseIndex>

                <BaseIndex
                  ref="baseIndex"
                  v-if="executionOperation.entryMovementItems.length > 0"
                  :loading="loading"
                  :pageLoading="pageLoading"
                  :table-headers="entryMovementItemsHeaders"
                  :table-items="executionOperation.entryMovementItems"
                  :indexNested="true"
                  :maskFields="entryMovementItemsHeadersMaskFields"
                  :disablePagination="true"
                  :containSearchBar="false"
                  :containTopToolbar="false"
                  :hasTableTitle="true"
                  tableTitle="Produtos Produzidos"
                  class="mt-3"
                >

                  <!-- <template slot="tableFooter">
                    <tr>
                      <td colspan="3"><strong class="title">Total dos Itens Consumidos</strong></td>
                      <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.exitMovementItemsTotalPrice | formatCurrency }}</strong></td>
                    </tr>
                  </template> -->

                </BaseIndex>

              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>

      </v-col>

      <v-col cols="12" class="">

        <BaseIndex
          ref="baseIndex"
          :loading="loading"
          :pageLoading="pageLoading"
          :table-headers="exitMovementItemsTotalHeaders"
          :table-items="entry.periodExecutionReport.exitMovementItems.items"
          :indexNested="true"
          :maskFields="exitMovementItemsTotalHeadersMaskFields"
          :disablePagination="true"
          :containSearchBar="false"
          :hasTableTitle="true"
          :containTopToolbar="false"
          tableTitle="Total de Itens Consumidos"
        >

          <template slot="tableFooter">
            <tr class="d-none d-md-table-row">
              <td colspan="5"><strong class="title">Total dos Itens Consumidos</strong></td>
              <td colspan="1" class="text-xs-right title"><strong>{{ this.entry.periodExecutionReport.exitMovementItems.cost | formatCurrency }}</strong></td>
            </tr>

            <!-- for mobile only -->
            <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">Total dos Itens Consumidos</div>
                <div class="v-data-table__mobile-row__cell"><strong>{{ this.entry.periodExecutionReport.exitMovementItems.cost | formatCurrency }}</strong></div>
              </td>
            </tr>
          </template>

        </BaseIndex>

      </v-col>

      <v-col cols="12" class="">

        <BaseIndex
          ref="baseIndex"
          :loading="loading"
          :pageLoading="pageLoading"
          :table-headers="employeesTotalHeaders"
          :table-items="entry.periodExecutionReport.employees.items"
          :indexNested="true"
          :maskFields="employeesTotalHeadersMaskFields"
          :disablePagination="true"
          :containSearchBar="false"
          :hasTableTitle="true"
          :containTopToolbar="false"
          tableTitle="Total de Funcionários"
        >

          <template slot="tableFooter">
            <tr class="d-none d-md-table-row">
              <td colspan="3"><strong class="title">Total dos Funcionários</strong></td>
              <td colspan="1" class="text-xs-right title"><strong>{{ this.entry.periodExecutionReport.employees.cost | formatCurrency }}</strong></td>
            </tr>

            <!-- for mobile only -->
            <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">Total dos Funcionários</div>
                <div class="v-data-table__mobile-row__cell"><strong>{{ this.entry.periodExecutionReport.employees.cost | formatCurrency }}</strong></div>
              </td>
            </tr>
          </template>

        </BaseIndex>

      </v-col>

      <v-col cols="12" class="">

        <BaseIndex
          ref="baseIndex"
          :loading="loading"
          :pageLoading="pageLoading"
          :table-headers="patrimoniesTotalHeaders"
          :table-items="entry.periodExecutionReport.machinery.items"
          :indexNested="true"
          :maskFields="patrimoniesTotalHeadersMaskFields"
          :disablePagination="true"
          :containSearchBar="false"
          :hasTableTitle="true"
          :containTopToolbar="false"
          tableTitle="Total de Patrimônios"
        >

          <template slot="tableFooter">
            <tr class="d-none d-md-table-row">
              <td colspan="5"><strong class="title">Total dos Patrimônios</strong></td>
              <td colspan="1" class="text-xs-right title"><strong>{{ this.entry.periodExecutionReport.machinery.cost | formatCurrency }}</strong></td>
            </tr>

             <!-- for mobile only -->
            <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">Total dos Patrimônios</div>
                <div class="v-data-table__mobile-row__cell"><strong>{{ this.entry.periodExecutionReport.machinery.cost | formatCurrency }}</strong></div>
              </td>
            </tr>
          </template>

        </BaseIndex>

      </v-col>

      <v-col cols="12" class="">
        <BaseIndex
          ref="baseIndex"
          :loading="loading"
          :pageLoading="pageLoading"
          :table-headers="entryMovementItemsTotalHeaders"
          :table-items="entry.periodExecutionReport.entryMovementItems.items"
          :indexNested="true"
          :maskFields="entryMovementItemsTotalHeadersMaskFields"
          :disablePagination="true"
          :containSearchBar="false"
          :containTopToolbar="false"
          :hasTableTitle="true"
          tableTitle="Produtos Produzidos"
        >

          <!-- <template slot="tableFooter">
            <tr>
              <td colspan="3"><strong class="title">Total dos Itens Consumidos</strong></td>
              <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.exitMovementItemsTotalPrice | formatCurrency }}</strong></td>
            </tr>
          </template> -->

        </BaseIndex>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Área do Ciclo</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{numberToDecimal(entry.area)}} ha
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Custo por Ha</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{numberToCurrency(entry.periodExecutionReport.costByHa)}} por ha
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="py-2">
            <span class="text-h6">Custo Total</span>
          </v-card-title>

          <v-card-text class="text-right">
            <span class="font-weight-bold text-h6">
              {{numberToCurrency(entry.periodExecutionReport.estimatedCost)}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>


    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseIndex from "@shared_components/base_index.vue";
import DateField from "@shared_components/date_field.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      activitiesHeaders: [
        { text: 'Funcionário', sortable: true, value: 'person.name' },
        { text: 'Duração', sortable: true, value: 'durationText' },
        { text: 'Patrimônio', sortable: true, value: 'patrimony.description' },
        { text: 'Implemento', sortable: true, value: 'implement.description' },
        { text: 'Preço', sortable: true, value: 'totalPrice' },
      ],
      activitiesHeadersMaskFields: [
        { field: 'totalPrice',mask: 'currency'}
      ],
      exitMovementItemsHeaders: [
        { text: 'Item', sortable: true, value: 'item.name' },
        { text: 'Quantidade', sortable: true, value: 'quantity' },
        { text: 'Unidade', sortable: true, value: 'item.unit.name' },
        { text: 'Preço Unit.', sortable: true, value: 'unitPrice' },
        { text: 'Preço Total', sortable: true, value: 'price' },
      ],
      exitMovementItemsHeadersMaskFields: [
        { field: 'unitPrice', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number'},
        { field: 'price',mask: 'currency'}
      ],
      entryMovementItemsHeaders: [
        { text: 'Produto', sortable: true, value: 'item.name' },
        { text: 'Quantidade Produzida', sortable: true, value: 'quantity' },
        { text: 'Quantidade Disponível', sortable: true, value: 'availableQuantity' },
        { text: 'Estoque', sortable: true, value: 'storage.name' },
      ],
      entryMovementItemsHeadersMaskFields: [
        { field: 'quantity', mask: 'number_unit', unit: 'Kg' },
        { field: 'availableQuantity', mask: 'number_unit', unit: 'Kg'},
      ],
      exitMovementItemsTotalHeaders: [
        { text: 'Item', sortable: true, value: 'name' },
        { text: 'Qtd. Total Consumida', sortable: true, value: 'quantity' },
        { text: 'Unidade', sortable: true, value: 'unitName' },
        { text: 'Qtd. Restante em Estoque', sortable: true, value: 'stockQuantity' },
        { text: 'Preço Unit.', sortable: true, value: 'unitPrice' },
        { text: 'Preço Total', sortable: true, value: 'cost' },
      ],
      exitMovementItemsTotalHeadersMaskFields: [
        { field: 'unitPrice', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number'},
        { field: 'stockQuantity', mask: 'number'},
        { field: 'cost',mask: 'currency'}
      ],
      employeesTotalHeaders: [
        { text: 'Funcionário', sortable: true, value: 'name' },
        { text: 'Tempo de Trabalho', sortable: true, value: 'workTime' },
        { text: 'Valor Hora', sortable: true, value: 'hourlyPrice' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      employeesTotalHeadersMaskFields: [
        { field: 'hourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
      patrimoniesTotalHeaders: [
        { text: 'Patrimônio', sortable: true, value: 'patrimonyName' },
        { text: 'Valor Hora Pat.', sortable: true, value: 'patrimonyHourlyPrice' },
        { text: 'Implemento', sortable: true, value: 'implementName' },
        { text: 'Valor Hora Imp.', sortable: true, value: 'implementHourlyPrice' },
        { text: 'Tempo', sortable: true, value: 'totalTime' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      patrimoniesTotalHeadersMaskFields: [
        { field: 'patrimonyHourlyPrice', mask: 'currency'},
        { field: 'implementHourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
      entryMovementItemsTotalHeaders: [
        { text: 'Produto', sortable: true, value: 'name' },
        { text: 'Quantidade Produzida', sortable: true, value: 'quantity' },
      ],
      entryMovementItemsTotalHeadersMaskFields: [
        { field: 'quantity', mask: 'number_unit', unit: 'Kg' },
      ],
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageLoading: { 
      type: Boolean,
      default: false
    },
  },
  components: {
    BaseIndex: BaseIndex,
    DateField: DateField,
    MaskedTextField: MaskedTextField,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  computed: {
    varietiesModel: function() {
      return this.entry.varieties ? this.entry.varieties.map(item => item.id) : [];
    },
  },
  methods: {
    operationTypeColor: function(operationType) {
      switch(operationType) {
        case "soil_preparation":
          return "#8D6E63"; //brown
        case "planting":
          return "#66BB6A"; //green
        case "fertilization":
          return "#FFA726"; //orange
        case "application":
          return "#FF7043"; //deep-orange
        case "crop":
          return "#29B6F6"; //light-blue
        default:
          return "#78909C"; //blue-grey
      }
    },
    operationTypeIcon: function(operationType) {
      switch(operationType) {
        case "soil_preparation":
          return "mdi-tractor";
        case "planting":
          return "mdi-seed";
        case "fertilization":
          return "mdi-sprinkler"; 
        case "application":
          return "mdi-spray";
        case "crop":
          return "mdi-sprout";
        default:
          return "mdi-leaf";
      }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
